import { Link } from "react-router-dom";
import { Linkedin, Facebook, Instagram, MessageCircle, MapPin, Mail } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";
import { CONTACT } from "../i18n/translations";

const Footer = () => {
  const { t } = useLang();
  const year = new Date().getFullYear();

  return (
    <footer data-testid="site-footer" className="bg-[#0A192F] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3 mb-6">
              <span className="inline-flex items-center justify-center w-10 h-10 bg-white text-[#0A192F] font-serif text-xl">
                M
              </span>
              <div className="flex flex-col leading-tight">
                <span className="font-serif text-xl">Mercurio</span>
                <span className="text-[10px] uppercase tracking-[0.25em] text-[#D4AF37]">
                  Advisors Group
                </span>
              </div>
            </div>
            <p className="text-gray-300 max-w-md leading-relaxed">{t.footer.tagline}</p>

            <div className="flex items-center gap-4 mt-8">
              <a data-testid="footer-linkedin" href={CONTACT.social.linkedin} aria-label="LinkedIn" className="p-2 border border-white/20 hover:border-[#D4AF37] hover:text-[#D4AF37] transition-colors">
                <Linkedin className="w-4 h-4" />
              </a>
              <a data-testid="footer-facebook" href={CONTACT.social.facebook} aria-label="Facebook" className="p-2 border border-white/20 hover:border-[#D4AF37] hover:text-[#D4AF37] transition-colors">
                <Facebook className="w-4 h-4" />
              </a>
              <a data-testid="footer-instagram" href={CONTACT.social.instagram} aria-label="Instagram" className="p-2 border border-white/20 hover:border-[#D4AF37] hover:text-[#D4AF37] transition-colors">
                <Instagram className="w-4 h-4" />
              </a>
              <a data-testid="footer-whatsapp" href={CONTACT.social.whatsapp} aria-label="WhatsApp" className="p-2 border border-white/20 hover:border-[#D4AF37] hover:text-[#D4AF37] transition-colors">
                <MessageCircle className="w-4 h-4" />
              </a>
            </div>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-xs uppercase tracking-[0.25em] text-[#D4AF37] mb-5">{t.footer.explore}</h4>
            <ul className="space-y-3 text-sm text-gray-300">
              <li><Link to="/" className="hover:text-white">{t.nav.home}</Link></li>
              <li><Link to="/about" className="hover:text-white">{t.nav.about}</Link></li>
              <li><Link to="/services" className="hover:text-white">{t.nav.services}</Link></li>
              <li><Link to="/digital" className="hover:text-white">{t.nav.digital}</Link></li>
              <li><Link to="/contact" className="hover:text-white">{t.nav.contact}</Link></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-xs uppercase tracking-[0.25em] text-[#D4AF37] mb-5">{t.footer.divisions_h}</h4>
            <ul className="space-y-3 text-sm text-gray-300">
              <li><Link to="/services" className="hover:text-white">Europath Consultancy</Link></li>
              <li><Link to="/digital" className="hover:text-white">Digitia</Link></li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-xs uppercase tracking-[0.25em] text-[#D4AF37] mb-5">{t.footer.contact_h}</h4>
            <ul className="space-y-3 text-sm text-gray-300">
              <li className="flex items-start gap-3"><MapPin className="w-4 h-4 mt-0.5 text-[#D4AF37]" /> {CONTACT.address}</li>
              <li className="flex items-start gap-3"><Mail className="w-4 h-4 mt-0.5 text-[#D4AF37]" /> <a href={`mailto:${CONTACT.email}`} className="hover:text-white">{CONTACT.email}</a></li>
              <li className="flex items-start gap-3"><MessageCircle className="w-4 h-4 mt-0.5 text-[#D4AF37]" /> <a href={CONTACT.whatsapp_link} target="_blank" rel="noopener noreferrer" className="hover:text-white">{CONTACT.whatsapp}</a></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 mt-16 pt-8 flex flex-col md:flex-row md:items-center md:justify-between gap-3 text-xs text-gray-400">
          <p>© {year} Mercurio Advisors Group. {t.footer.legal}</p>
          <p className="uppercase tracking-[0.25em] text-[#D4AF37]">{t.footer.built}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
